import { render } from "./MediaLinksBar.vue?vue&type=template&id=74040406&scoped=true"
import script from "./MediaLinksBar.vue?vue&type=script&lang=js"
export * from "./MediaLinksBar.vue?vue&type=script&lang=js"

import "./MediaLinksBar.vue?vue&type=style&index=0&id=74040406&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74040406"]])

export default __exports__